import { render, staticRenderFns } from "./AgregarRecargoTypeModal.vue?vue&type=template&id=2c56ca54"
import script from "./AgregarRecargoTypeModal.vue?vue&type=script&lang=js"
export * from "./AgregarRecargoTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports